<template>
  <div class="fzxw">
      <div class="fzImg" v-for="(item,i) in fzImg" :key="i" v-if="$route.query.id - 0 === i" v-cloak>
        <div class="loadImg">
          <img :src="item.img1" alt="">
          <img class="ruanzhu" src="../../static/img/软著@2x.png" alt="" @click="$router.push({path:item.path })">
        </div>
          <img :src="item.img2" alt="">
          <img :src="item.img3" alt="">
          <img @click="skip('http://icid.iachina.cn/?columnid_url=201509301401')" :src="item.img4" alt="">
      </div>
  </div>
</template>

<script>
export default {
  name: 'fzxw',
   components: {
  },
  data () {
    return {
      fzImg: [
        {
          img1: require('../../static/img/rb1.png'),
          img2: require('../../static/img/rb2.png'),
          img3: require('../../static/img/rb3.png'),
          img4: require('../../static/img/rb4.png'),
          id: '0',
          path: '/ruanzhu?id=0'
        },
        {
           img1: require('../../static/img/lhb1.png'),
          img2: require('../../static/img/lhb2.png'),
          img3: require('../../static/img/lhb3.png'),
          img4: require('../../static/img/lhb4.png'),
          id: '1',
          path: '/ruanzhu?id=1'
        },
        {
          img1: require('../../static/img/xr1.png'),
          img2: require('../../static/img/xr2.png'),
          img3: require('../../static/img/xr3.png'),
          img4: require('../../static/img/xr4.png'),
          id: '2',
          path: '/ruanzhu?id=2'
        },
        {
          img1: require('../../static/img/zzb1.png'),
          img2: require('../../static/img/zzb2.png'),
          img3: require('../../static/img/zzb3.png'),
          img4: require('../../static/img/zzb4.png'),
          id: '3',
          path: '/ruanzhu?id=3'
        },
        {
          img1: require('../../static/img/lcb1.png'),
          img2: require('../../static/img/lcb2.png'),
          img3: require('../../static/img/lcb3.png'),
          img4: require('../../static/img/lcb4.png'),
          id: '4',
          path: '/ruanzhu?id=4'
        },
        {
          img1: require('../../static/img/thb1.png'),
          img2: require('../../static/img/thb2.png'),
          img3: require('../../static/img/thb3.png'),
          img4: require('../../static/img/thb4.png'),
          id: '5',
          path: '/ruanzhu?id=5'
        },
        {
          img1: require('../../static/img/dlb1.png'),
          img2: require('../../static/img/dlb2.png'),
          img3: require('../../static/img/dlb3.png'),
          img4: require('../../static/img/dlb4.png'),
          id: '6',
          path: '/ruanzhu?id=6'
        },
        {
          img1: require('../../static/img/xbb1.png'),
          img2: require('../../static/img/xbb2.png'),
          img3: require('../../static/img/xbb3.png'),
          img4: require('../../static/img/xbb4.png'),
          id: '7',
          path: '/ruanzhu?id=7'
        },
        {
          img1: require('../../static/img/fz1.png'),
          img2: require('../../static/img/fz2.png'),
          img3: require('../../static/img/fz3.png'),
          img4: require('../../static/img/fz4.png'),
          id: '8',
          path: '/ruanzhu?id=8'
        }
      ]
    }
  },
  mounted() {
      let id = this.$route.query.id
      if(this.isMobile()) {

            this.$router.push({path:'/fzproducts?id=', query: {id:id}})
            } else {
            this.$router.push({path:'/cpfz?page=3&id=', query: {id: id}})
            }
  },
  methods: {
    skip (url) {
      location.href = url
    },
     isMobile() {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        return flag;
    }
  }
}
</script>
<style lang="scss" scoped>
.fzxw{
  .fzImg{
    height: 26.07rem;
    padding-bottom: .1rem;
    width: 100%;
    img{
      display: block;
      width: 100%;
      // height: 100%;
    }
    [v-cloak] {
	   display: none;
	 }
   .loadImg{
     width: 100%;
     position: relative;
     img{
      width: 100%;
       display: block;
     }
     .ruanzhu{
       width: .98rem;
       height: .98rem;
       display: block;
       position: absolute;
       bottom: .64rem;
       left: 34.9%;

     }
   }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Fzproducts.vue